  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faqrs-question').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.faqrs-item');
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.faqrs-item').forEach((i) => {
          i.classList.remove('faqrs-active');
          i.querySelector('.faqrs-question').setAttribute('aria-expanded', 'false');
        });

        if (!expanded) {
          item.classList.add('faqrs-active');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });


  document.addEventListener("click", function (e) {
    // 1. Look for any click on a link with href="#support"
    const link = e.target.closest('a[href="#support"]');
    
    if (link) {
      // 2. Stop the link from jumping to a new page
      e.preventDefault();
      
      // 3. Trigger the Help Scout Beacon
      if (typeof Beacon !== 'undefined') {
        Beacon('open');
      } 
      // Fallback: If you are using a custom wrapper named HSBEACON
      else if (typeof HSBEACON !== 'undefined') {
        HSBEACON.open('contact');
      } 
      else {
        console.warn("Help Scout Beacon is not loaded on this page.");
      }
    }
  });
